import React, { useEffect, useState } from 'react';
import { useFetch } from 'hooks/use-fetch';
import AutosuggestBasic from 'layouts/header/search/components/autosuggest-basic';
import SuggestionView from 'layouts/header/search/components/suggestion-view';
import Icon from 'atomic/icon';

import './autosuggest.scss';

interface SuggestionsFetchRequestedInterface {
    highlighted: string;
    phrase: string;
    url: string;
}

const Autosuggest: React.FC<{
    onSubmit: () => void;
    onChange: any;
    onFocus?: () => void;
    onBlur?: () => void;
    searchValue: string;
    selectedValue: {
        value: string;
        label: string;
    };
}> = ({ onSubmit, searchValue, selectedValue, onChange, onFocus, onBlur }) => {
    const [AutosuggestComponent, setAutosuggestComponent] = useState<React.ComponentType<any>>(() => AutosuggestBasic);
    const { get } = useFetch('/search/suggestions', { method: 'GET' });

    const [suggestions, setSuggestions] = useState<SuggestionsFetchRequestedInterface[]>([]);

    useEffect(() => {
        import('react-autosuggest').then(mod => {
            setAutosuggestComponent(() => mod.default);
        });
    }, []);

    const onSuggestionsFetchRequested = ({ value }: any): void => {
        if (value.length >= 3) {
            get({ query: value, categoryId: selectedValue.value !== '' ? selectedValue.value : '*' })
                .then((response: SuggestionsFetchRequestedInterface[]) => {
                    if (response) {
                        setSuggestions(response);
                    }
                });
        }
    };

    const onSuggestionsClearRequested = (): void => setSuggestions([]);

    const getSuggestionValue = (suggestion: any): string => suggestion.highlighted ? suggestion.phrase : '';

    const inputProps = {
        name: 'query',
        placeholder: 'Znajdź produkt...',
        value: searchValue,
        onChange,
        onFocus,
        onBlur
    };

    let clearButton;

    if (searchValue && searchValue.length >= 1) {
        clearButton = (
            <button
                type="button"
                className="react-autosuggest__clear-button"
                onClick={(): void => onChange('', { newValue: '' })}
            >
                <Icon name="x-circle" size={18} />
            </button>
        );
    }

    return (
        <div className="react-autosuggest">
            <AutosuggestComponent
                suggestions={suggestions}
                onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                onSuggestionsClearRequested={onSuggestionsClearRequested}
                getSuggestionValue={getSuggestionValue}
                renderSuggestion={(suggestion: any): any => <SuggestionView suggestion={suggestion} />}
                inputProps={inputProps}
                onSuggestionSelected={onSubmit}
            />
            {clearButton}
        </div>
    );
};

export default Autosuggest;
